import { z } from 'zod'

import { SnippetSharingType } from 'common/settings/constants/LiveChat'

const SnippetResponse = z.object({
  snippet_id: z.number(),
  title: z.string(),
  content: z.string(),
  type_title: z.nativeEnum(SnippetSharingType),
})

export const snipppetsSchemas = {
  fetchSnippets: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.undefined(),
    response: z.object({
      snippets: z.array(SnippetResponse),
    }),
  },
  createSnippet: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      type: z.number(),
      title: z.string(),
      content: z.string(),
      type_title: z.nativeEnum(SnippetSharingType),
    }),
    response: z.object({
      title: z.string(),
      content: z.string(),
      snippet_id: z.number(),
      type_title: z.nativeEnum(SnippetSharingType),
    }),
  },
  deleteSnippet: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      snippet_id: z.number(),
    }),
    response: SnippetResponse,
  },
  editSnippet: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      snippet_id: z.number(),
      title: z.string(),
      content: z.string(),
      type_title: z.nativeEnum(SnippetSharingType),
    }),
    response: SnippetResponse,
  },
  transformContentSnippet: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      subscriber_id: z.string(),
      snippet_id: z.number(),
      content: z.string(),
    }),
    response: z.object({
      content: z.string(),
    }),
  },
}
